export const NAVIGATION_TARGET = {
  REGISTRATION: 'registration',
  LOGIN: 'login',
} as const;

export type NavigationTarget = (typeof NAVIGATION_TARGET)[keyof typeof NAVIGATION_TARGET];
